module.exports = __webpack_public_path__ + "static/media/intervencion3.347ecbc9.jpg";